import { LitElement, html } from '@hh/global.js'
class CountrySelectorPopup extends LitElement {
  static properties = {}

  constructor() {
    super()
    this.addFocusTrap = this.addFocusTrap.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
    this._init()
  }

  _init() {
    if (!window.mdApp_openAndRefreshModal || !window.mdApp_closeModal) return

    this.classList.add('block')
    this.classList.remove('hidden')
  }

  handleCustomSelectorClick() {
    window.mdApp_openAndRefreshModal()
    document.addEventListener('keydown', this.closeOnEscape.bind(this))
    this.modalWrapper = document.querySelector('#md-app-embed__modal')
    // Custom focus trap is required because we're trapping focus within the modal
    // but this component only contains the trigger button
    this.modalWrapper.addEventListener('keydown', this.onTrapFocus.bind(this))
    this.addFocusTrap()
  }

  closeOnEscape(e) {
    if (e.key !== 'Escape') return
    window.mdApp_closeModal()
    document.removeEventListener('keydown', this.closeOnEscape)
    this.modalWrapper.removeEventListener(
      'keydown',
      this.onTrapFocus.bind(this)
    )
  }

  isHidden(element) {
    return (
      element.getAttribute('tabindex') === '-1' ||
      element.hasAttribute('hidden') ||
      (element.hasAttribute('aria-hidden') &&
        element.getAttribute('aria-hidden') !== 'false') ||
      element.style.display === `none` ||
      element.style.opacity === `0`
    )
  }

  isFocusable(element) {
    return (
      (!element.disabled && element.hasAttribute('tabindex')) ||
      ((element instanceof HTMLAnchorElement ||
        element instanceof HTMLAreaElement) &&
        element.hasAttribute('href')) ||
      element instanceof HTMLButtonElement ||
      element instanceof HTMLInputElement ||
      element instanceof HTMLTextAreaElement ||
      element instanceof HTMLSelectElement ||
      element instanceof HTMLIFrameElement
    )
  }

  addFocusTrap() {
    const focusableSelectors = `
      a[href]:not([disabled]),
      button:not([disabled]),
      textarea:not([disabled]),
      input[type='text']:not([disabled]),
      input[type='radio']:not([disabled]),
      input[type='checkbox']:not([disabled]),
      select:not([disabled])
    `
    const focusableChildren =
      Array.from(this.modalWrapper.querySelectorAll(focusableSelectors)) || []
    this.firstFocusableElement = focusableChildren.find(
      (element) => !this.isHidden(element)
    )
    this.lastFocusableElement = focusableChildren.findLast(
      (element) => !this.isHidden(element)
    )

    this.firstFocusableElement.focus()
  }

  onTrapFocus(e) {
    const isTabPressed = e.key === 'Tab' || e.keyCode === 9
    if (!isTabPressed) return

    if (e.shiftKey) {
      if (document.activeElement === this.firstFocusableElement) {
        this.lastFocusableElement.focus()
        e.preventDefault()
      }
    } else {
      if (document.activeElement === this.lastFocusableElement) {
        this.firstFocusableElement.focus()
        e.preventDefault()
      }
    }
  }

  render() {
    return html`<slot @click="${this.handleCustomSelectorClick}"></slot>`
  }
}

customElements.define('country-selector-popup', CountrySelectorPopup)

// TIMEX ADA Updates
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.md-modal__bodyContent__text')[0]?.setAttribute('role', 'heading')
  document.querySelectorAll('.md-modal__bodyContent__text')[0]?.setAttribute('aria-level', 2)
  document.getElementById("label-md-modal__dialog")?.setAttribute("role", "heading")
  document.getElementById("label-md-modal__dialog")?.setAttribute("aria-level", 1)
})
